import office from '@/taskpane/officejs/office-wrapper'
import MessageArgs from '../messages/message-args'
interface ReplyTrackingChangedArgs extends MessageArgs {
  replyTrackingId?: string
}

export default async function replyTrackingChangedHandler(data: ReplyTrackingChangedArgs) {
  await office.customProps.setReplyTrackingId(data.replyTrackingId)
}
